import template from './report_definition.html';

class ReportDefinitionDisplayViewModel
{
	constructor (params, element)
	{
		this.params = params;
		this.element = element;
		//Params		
		this.title = ko_helper.safe_observable(params.title || '');
		this.report_definition_id = ko_helper.safe_observable(params.report_definition_id || '');
		this.version = ko_helper.safe_observable(params.version || '');
		this.generate_on_save = ko_helper.safe_observable(params.generate_on_save || 'yes');
		this.refresh_results = params.call_back ?? null;
		//Local
		this.report_id = ko.observable();
		this.report_definition = ko.observable('');
		this.active = ko.observable(true);
		this.query_text = ko.observable('');
		this.form_scope_id = ko.observable('');
		this.description = ko.observable('');
		this.group = ko.observable('');
		this.report_type = ko.observable('');
		this.name = ko.observable('');
		this.form_scope_list = ko.observableArray([]);
		this.available_types = ko.observableArray(['Function', 'Query']);
		this.selected_type = ko.observableArray(['Function']);
		this.query_sql = ko.observable('');
		this.available_schemas = ko.observableArray([]);
		this.available_functions = ko.observableArray([]);
		this.selected_function = ko.observable('');
		this.raw_function_data = ko.observableArray([]);
		this.raw_table_data = ko.observableArray([]);
		this.selected_schema = ko.observable('');
		this.available_tables = ko.observableArray([]);
		this.selected_table = ko.observable('');
		this.available_columns = ko.observableArray([]);
		this.numeric_columns = ko.observableArray([]);
		this.selected_columns = ko.observableArray([]);

		//this.selected_columns.subscribe(function() {this.determine_group_by()},this);
		this.version.subscribe(function() {this.load_definition()},this)
		
		this.def_agg_columns = ko.observable();
		this.agg_columns = ko.observableArray([{ 
			func: ko.observable(''), 
			field: ko.observable(''),
			alias: ko.observable('')
		}]);
		this.agg_columns.subscribe(function() {this.determine_group_by()},this);

		this.def_agg_columns.subscribe(option => {
			if (option && (this.agg_columns().length === 0 || this.agg_columns() === ''))
				this.agg_columns.push({ func: ko.observable(''), field: ko.observable(''), alias: ko.observable('')});
			}
		);

		this.def_filter = ko.observable();
		this.available_filter_join_options = ko.observableArray(['AND', 'OR']);
		this.selected_filter_join_option = ko.observable('');

		this.filters = ko.observableArray([{ 
			field: ko.observable(''), 
			operator: ko.observable(''), 
			value: ko.observable('') 
		}]);

		this.selected_filter_join_option.subscribe(option => {
			if (option && (this.filters().length === 0 || this.filters() === ''))
				this.filters.push({ field: ko.observable(''), operator: ko.observable(''), value: ko.observable('') });
		});

		this.require_group_by = ko.observable(false);
		this.group_by_columns = ko.observableArray([]);
		this.order_by = ko.observable();
		this.order_by_fields = ko.observableArray([{ 
			field: ko.observable(''), 
			sortorder: ko.observable('ASC') 
		}]);
		this.order_by.subscribe(option => {
			if (option && (this.order_by_fields().length === 0 || this.order_by_fields() === ''))
				this.order_by_fields.push({ field: ko.observable(''), sortorder: ko.observable('ASC') });
			}
		);

		this.sortfield = ko.observable('');
		this.sortorder = ko.observable('');
		this.available_groups = ko.observableArray([]);
		this.settings = ko.observable();
		
		this.selected_type.subscribe(type => {
			if (type)
				this.selected_schema('');
		});

		this.selected_schema.subscribe(schema => {
			if (schema && this.selected_type() === 'Function')
			{
				let functions = this.raw_function_data().filter(item => item.routine_schema === schema).map(item => item.routine_name);
				this.available_functions(functions);
			}
			else if (schema && this.selected_type() === 'Query')
			{
				let tables = this.raw_table_data().filter(item => item.schema === schema).map(item => item.name);
				// Extract unique table names
				let unique_tables = [...new Set(tables.map(item => item))];
				this.available_tables(unique_tables);
			}
		});

		this.selected_table.subscribe(table => {
			if (table && this.selected_schema != '' && this.selected_type() === 'Query')
			{
				this.get_all_columns()
			}
		});

		this.def_query_ui_fields = ko.observable(false);
		this.query_ui_fields = ko.observableArray([]);
		this.def_query_ui_fields.subscribe(sub_yn => {
			if (sub_yn && this.query_ui_fields().length == 0){
				this.add_query_ui_field('', '', 'text', '', '=', '');
			}
		});

		this.ui_fields = ko.observableArray([{
			label: ko.observable(''), 
			name: ko.observable(''), 
			type: ko.observable(''),
			default_value: ko.observable('')
		}]);

		this.load();
	}

	add_query_ui_field(label, name, type, list_options,	operator, default_value){
		this.query_ui_fields.push(
			{
			label: ko.observable(label), 
			name: ko.observable(name), 
			type: ko.observable(type),
			list_options: ko.observable(list_options),
			operator: ko.observable(operator),
			default_value: ko.observable(default_value)
			}
		)
	}

	async load(){
		await this.get_schemas();
		await this.get_all_tables();
		await this.get_report_groups();
		await this.load_definition();
	}

	async get_schemas ()
	{
		let settings_result = await Grape.fetches.getJSON('/api/setting/reports.exposed_schemas');
		this.settings(settings_result.value);

		let exposed_schemas = []
		if (settings_result.value && settings_result.value != '')
			exposed_schemas = settings_result.value.split(',');
		else 
			exposed_schemas.push('reports');

		let filter = exposed_schemas.map((item) => { return {'field': 'routine_schema', 'operator': '=', 'value': item} });

		let body = {
			schema: 'grape',
			table: 'v_pg_functions',
			filter: filter,
			filter_join: 'OR',
			limit: 5000
		};
		let data = await Grape.fetches.getJSON('/api/record', body);
		if (data.status === 'OK'){
			this.raw_function_data(data.records);
			// Extract unique schemas
			let unique_schemas = [...new Set(data.records.map(item => item.routine_schema))];
			this.available_schemas(unique_schemas);
		}
	}
		
	async get_all_tables ()
	{
		let exposed_schemas = this.available_schemas();
		let filter = exposed_schemas.map((item) => { return {'field': 'schema', 'operator': '=', 'value': item} });

		let response = await Grape.fetches.getJSON('/api/record', {
			schema: 'grape',
			table: 'v_pg_tables',
			limit: 5000,
			fields: ['name', 'schema'],
			filter: filter,
			filter_join: 'OR'
		});
		if (response.status === 'OK')
			this.raw_table_data(response.records);
		else
			console.error(response);
	}

	async get_report_groups()
	{
		let available_groups = [];
		let result = await Grape.fetches.getJSON('/api/report/definition/groups');
		if (result.status !== 'ERROR')
		{
			if (result.records && (result.records != null)){
				result.records.forEach((record) => {
					if(available_groups.indexOf(record.group) == -1)
						available_groups.push(record.group);
				});
			}
			this.available_groups(available_groups);
		}else{
			Grape.alert_api_error(result);
		}
	}
/*
	what_am_i(type){
		return type == 'list' ? 1 : 0;
	}
*/
	async get_all_columns ()
	{
		let response = await Grape.fetches.getJSON('/api/record', {
			schema: 'grape',
			table: 'v_pg_columns',
			limit: 5000,
			filter: [
				{field: 'schema_name', 'operator': '=', value: this.selected_schema()},
				{field: 'table_name', 'operator': '=', value: this.selected_table()}
			]
		});
		if (response.status === 'OK'){
			this.available_columns(response.records.map(item => item.column_name));
			this.numeric_columns(response.records.filter(item => item.datatype == 'numeric').map(item => item.column_name));
		}
		else
			console.error(response);
	}

	async load_definition(){
		if (this.report_definition_id() == '0'){
			this.report_definition({
				'report_definition_id': null,
				'version': null,
				'active' : null
			});
			return;
		}

		let request_obj = {
			schema: 'reports',
			table: 'report_definition',
			filter_join: 'AND',
			filter: [
				{ field: 'report_definition_id', operand: '=', value: this.report_definition_id()},
				{ field: 'version', operand: '=', value: this.version()}
			]
		};
		let response = await Grape.fetches.getJSON('/api/record', request_obj);
		if (response.status !== 'OK') {
			console.error('Report definition not found:', this.report_definition_id());
			return;
		}
		this.report_definition(response.records[0]);

		this.name(this.report_definition().name);
		this.description(this.report_definition().description);
		this.group(this.report_definition().group);
		this.selected_type(this.report_definition().report_type === 'query' ? 'Query' : 'Function');
		this.selected_schema(this.report_definition().default_function_criteria.selected_schema);
		this.selected_table(this.report_definition().default_function_criteria.selected_table);

		await this.get_all_columns();

		if (this.report_definition().report_type = 'query'){
			this.selected_columns(this.report_definition().default_function_criteria.selected_columns || []);	
			if (this.report_definition().default_function_criteria.aggregate_columns && this.report_definition().default_function_criteria.aggregate_columns.length > 0){
				this.agg_columns(this.report_definition().default_function_criteria.aggregate_columns);
				this.group_by_columns(this.report_definition().default_function_criteria.group_by);
				this.def_agg_columns(true);
				this.require_group_by(true);
			}
			this.def_filter(this.report_definition().default_function_criteria.use_filter == 'YES' ? true : false);
			this.selected_filter_join_option(this.report_definition().default_function_criteria.filter_join || '');
			this.filters(this.report_definition().default_function_criteria.filter || []);

			// Query UI fields
			this.query_ui_fields([]);
			let q_ui_fields = this.report_definition().default_function_criteria.query_ui_fields || [];
			for (let field of q_ui_fields){
				this.add_query_ui_field(field.label, field.name, field.type, field.list_options,	field.operator, field.default_value);
			}
			this.def_query_ui_fields(this.report_definition().default_function_criteria.def_query_ui_fields == 'YES' ? true : false);
			
			if (this.report_definition().default_function_criteria.sort_fields && this.report_definition().default_function_criteria.sort_fields.length > 0){
				this.order_by(true);
				this.order_by_fields([]);
				for (let field of this.report_definition().default_function_criteria.sort_fields){
					this.order_by_fields.push({field: field.field, sortorder: field.sortorder});
				}
			}
			// backwards compatibility
			if (this.report_definition().default_function_criteria.sortfield && this.report_definition().default_function_criteria.sortfield != ''){
				this.order_by_fields.push(
					{field: this.report_definition().default_function_criteria.sortfield,
					sortorder: this.report_definition().default_function_criteria.sortorder});
			}
		}
	}

	btn_add_filter_row_click ()
	{
		this.filters.push({ 
			field: ko.observable(''), 
			operator: ko.observable(''), 
			value: ko.observable('')
		});
	}

	btn_remove_filter_row_click (index)
	{
		if (this.filters().length > 0)
			this.filters.splice(index, 1);
		if (this.filters().length == 0)
			this.def_filter(false);
	}

	btn_add_agg_column_row_click ()
	{
		this.agg_columns.push({ 
			func: ko.observable(''), 
			field: ko.observable(''),
			alias: ko.observable('')
		});
		this.determine_group_by();
	}
	btn_remove_agg_column_row_click(){
		if (this.agg_columns().length > 0)
			this.agg_columns.splice(index, 1);
		if (this.agg_columns().length == 0)
			this.def_agg_columns(false);
		this.determine_group_by();
	}

	btn_add_ui_field_row_click ()
	{
		this.ui_fields.push({ 
			label: ko.observable(''), 
			name: ko.observable(''), 
			type: ko.observable(''),
			default_value: ko.observable('')
		});
	}

	btn_add_query_ui_field_row_click ()
	{
		this.add_query_ui_field('', '', 'text', '', '=', '');
	}

	btn_remove_query_ui_field_row_click(index){
		if (this.query_ui_fields().length > 0)
			this.query_ui_fields.splice(index, 1);
		if (this.query_ui_fields().length == 0)
			this.def_query_ui_fields(false);
	}

	determine_group_by(){
		let require_group_by = false;
		let group_by_func = ['SUM','AVG'];
		let group_by_func_columns = [];
		for (let agg_field of this.agg_columns()){
			if (group_by_func.indexOf(agg_field.func) > -1){
				require_group_by = true;
				group_by_func_columns.push(agg_field.field);
			}
		}
		this.require_group_by(require_group_by);
		this.def_agg_columns(require_group_by);

		let gbc = [];
		if (require_group_by){
			for (let column of this.selected_columns()){
				if (group_by_func_columns.indexOf(column) == -1){
					gbc.push(column)
				}
			}
		}
		this.group_by_columns(gbc);
	}

	async btn_save_click ()
	{
		if (this.name() === '')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No Name provided'});
			return;
		}
		else if (typeof this.selected_schema() === 'undefined')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No schema selected'});
			return;
		}
		else if (typeof this.selected_function() === 'undefined' && this.selected_type() === 'Function')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No function selected'});
			return;
		}
		else if (typeof this.selected_table() === 'undefined' && this.selected_type() === 'Query')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No table/view selected'});
			return;
		}
		else if (this.selected_columns().length === 0 && this.selected_type() === 'Query')
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No columns selected'});
			return;
		}

		await this.save_report_definition();
		if (this.generate_on_save() == 'yes')
			await this.generate_report();
	}

	async save_report_definition(){
		let select_fields = this.selected_columns();
		let agg_def = [];

		if (this.require_group_by()){
			agg_def = ko.toJS(this.agg_columns()).map(item => ({
				func: item.func,
				field: item.field,
				alias: item.alias
			})).filter( (obj) => obj.field?obj.field != '' : false);

			for (let agg of agg_def){
				if (select_fields.indexOf(agg.field) > -1){
					select_fields.splice(select_fields.indexOf(agg.field),1);
				}
			}
		}
		//Filters
		let unwrap_filters = ko.toJS(this.filters()).map(filter => ({
			field: filter.field,
			operator: filter.operator,
			value: filter.value
		}));
		// Query UI Fields
		let unwrap_query_ui_fields = ko.toJS(this.query_ui_fields()).map(ui_field => ({
			label: ui_field.label,
			name: ui_field.name,
			type: ui_field.type,
			list_options: ui_field.list_options,
			operator: ui_field.operator,
			default_value: ui_field.default_value
		}));
		let query_default_values = {};
		for (let field of unwrap_query_ui_fields){
			if (field.name != '')
				Object.assign(query_default_values, { [`${field.name}`] : field.default_value });
		}
		
		let sort_fields = [];
		if (this.order_by()){
			sort_fields = ko.toJS(this.order_by_fields()).map(order_field => ({
				field: order_field.field,
				sortorder: order_field.sortorder
			})).filter( (obj) => obj.field?obj.field != '' : false);;
		}
		// Function source
		let ui_fields = ko.toJS(this.ui_fields());
		let unwrap_ui_fields = [];
		let default_values = {};
		if (Object.keys(ui_fields).length > 0)
		{
			unwrap_ui_fields = ui_fields.map(field => ({
				name: field.name,
				type: field.type,
				label: field.label
			}));

			for (const field of ui_fields ){
				if (field.type == 'json'){
					Object.assign(default_values, { [`${field.name}`] : JSON.parse(field.default_value) });
				}else{
					Object.assign(default_values, { [`${field.name}`] : field.default_value });
				}
			}	
		}

		let default_function_criteria , definition;
		if (this.selected_type() == 'Query'){
			default_function_criteria = {
				'selected_schema': this.selected_schema(),
				'selected_table': this.selected_table(),
				'selected_columns': select_fields,
				'aggregate_columns': agg_def,
				'group_by': this.group_by_columns(),
				'use_filter': this.def_filter() ? 'YES' : 'NO',
				'filter_join': this.def_filter() ? this.selected_filter_join_option() : '',
				'filter': this.def_filter() ? unwrap_filters : '',
				'def_query_ui_fields': this.def_query_ui_fields() ? 'YES' : 'NO',
				'query_ui_fields': unwrap_query_ui_fields,
				'query_default_values': query_default_values,
				'group_by': this.group_by_columns(),
				'sort_fields': sort_fields
			};
		}
		if (this.selected_type() == 'Function'){
			default_function_criteria = default_values;
			definition = {
				'function_schema': this.selected_schema(),
				'function_name': this.selected_function()
			}
		}

		let params = {
			'report_definition_id': this.report_definition().report_definition_id,
			'version': null,
			'active' : this.report_definition().active,
			'name': this.name(),
			'description': this.description(),
			'group': this.group(),
			'report_type': this.selected_type(),
			'definition': definition,
			'ui_fields': unwrap_ui_fields,
			'default_function_criteria': default_function_criteria
		};

		let data = await Grape.fetches.postJSON('/api/report/definition', params);
		if (data.status === 'ERROR'){
			console.error(response);
			return;
		}else{
			if (this.report_definition().report_definition_id == null){
				let url = `reports/definition/${data.report_definition_id}/${data.version}`;
				Grape.navigate(url);
			}else{
				this.report_definition_id(data.report_definition_id);
				this.version(data.version);
			}
		}
	}

	async generate_report (report_definition_id, version){
		let bindings = {
			initial_values : {
				'report_definition_id': this.report_definition_id(),
				'version': this.version(),
				'report_type': this.selected_type(),
				'function_schema': this.selected_schema(),
				'function_name': this.selected_table(),
				'active':true
			}
		};

		this.create_report_call = async (dialog_bindings) => {
			let func_var;
			if (dialog_bindings)
				func_var = {...bindings.initial_values, ...dialog_bindings.initial_values};
			else
				func_var = bindings.initial_values;

			let data = await Grape.fetches.postJSON('/api/report/create', func_var);
			if (data.status === 'OK')
			{
				if (!data.report)
				{
					Grape.alerts.alert({
						type: 'warning',
						message: 'User does not have the correct permission to run this report',
						title: 'Report Creation Error'
					});
				}
				else
				{
					this.report_id(data.report.report_id);
					this.generate_call_back();
				}
			}
		}

		this.create_report_function = async (dialog_bindings) => {
			if ( this.active() == true )
				this.create_report_call(dialog_bindings);
			else{
				let decision = await Grape.alerts.confirm({
					type: 'warning',
					message: 'Do you want to create a report for the old report definition version?',
					title: 'Confirm Report Generation',
					accept_text: 'Yes',
					cancel_text: 'No'
				});

				if (decision){
					if (decision === true)
						this.create_report_call(dialog_bindings);
					else
						return;
				}
			}
		};

		if (this.selected_type() === 'Function' && (this.ui_fields()?.length > 0)){
			let function_bindings = {
				title: 'Please provide parameters',
				initial_values : {
					ui_fields : this.ui_fields(),
					default_function_criteria : this.default_function_criteria(),
					report_function_criteria : {}
				}
			}
			Grape.show_dialog('ReportParamDialog', function_bindings,
			{
				onClose: (answer) => {
					if (answer){
						function_bindings.initial_values.report_function_criteria = answer.params;
						this.create_report_function(function_bindings);
					}else
						return;
				}
			});
		}else{
			if (this.selected_type() === 'Query' && (this.query_ui_fields()?.length > 0)){

				let unwrap_query_ui_fields = ko.toJS(this.query_ui_fields());
				let default_values = {};
				for (let field of unwrap_query_ui_fields){
					Object.assign(default_values, { [`${field.name}`] : field.default_value });
				}
				let query_bindings = {
					title: 'Please provide parameters',
					initial_values : {
						ui_fields : unwrap_query_ui_fields,
						default_function_criteria : default_values,
						report_function_criteria : {}
					}
				}
				Grape.show_dialog('ReportParamDialog', query_bindings,
				{
					onClose: (answer) => {
						if (answer){
							query_bindings.initial_values.report_function_criteria = answer.params;
							this.create_report_function(query_bindings);
						}
						else
							return;
					}
				});
			}else{
				this.create_report_function(null);
			}
		}
	}

	async generate_call_back(){
		let data = await Grape.fetches.getJSON('/api/report', { 'report_id': this.report_id()});
		if (data) {
			if (data.status === 'ERROR' || ['Error', 'Completed', 'New', 'Running', 'Starting', 'Pending'].indexOf(data.report_status) < 0) {
				console.error(data);
			}

			if (data.report_status === 'Error') {
				console.error(data);
			}
			else if (data.report_status === 'Completed') {
				if (this.refresh_results instanceof Function){
					return this.refresh_results(
						{report_definition_id: this.report_definition_id(),
						version: this.version(),
						report_id: this.report_id(),
						result_table: data.result_table});
				}
			}
			else {
				this.timer = setTimeout(
					() => {
						this.generate_call_back();
					},
					2000
				);
			}
		}
	}
}

export default {
	name: 'report-definition-display',
	viewModel: ReportDefinitionDisplayViewModel,
	module_type: 'ko',
	template: template
};